export default __webpack_public_path__ + "static/media/king_of_cups.d755e4fe.png";